import { createRouter, createWebHistory } from 'vue-router'
import PERK from '../views/PerkNpt.vue'
import DJOS from '../views/DjosNpt.vue'
import HVANCH from '../views/HvanchNpt.vue'
import DjosFeedback from '../views/DjosFeedback.vue'
import HvanchFeedback from '../views/HvanchFeedback.vue'
import PerkNPSDelivery from '../views/PerkNPSDelivery.vue'

export default createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', name: 'PERK', component: PERK, alias: '/perk', meta: { title: 'PERK - NEW MENU TEST' } },
    { path: '/perk-delivery', name: 'PERK-Delivery', component: PerkNPSDelivery, alias: '/perk-delivery', meta: { title: 'PERK - DELIVERY NPS' } },
    { path: '/djos', name: 'DJOS', component: DJOS, meta: { title: 'DJOS - NEW MENU TEST' } },
    { path: '/hvanch', name: 'HVANCH', component: HVANCH, meta: { title: 'HVANCH - NEW MENU TEST' } },
    { path: '/djos_feedback', name: 'DJOS-FEEDBACK', component: DjosFeedback, meta: { title: 'DJOS - FEEDBACK' } },
    { path: '/hvanch_feedback', name: 'HVANCH-FEEDBACK', component: HvanchFeedback, meta: { title: 'HVANCH - FEEDBACK' } },
    // { path: '/404', name: 'NotFound', component: NotFoundView },
    // { path: '/:catchAll(.*)', redirect: { name: 'NotFound' } }
  ]
})
